import React, { Component } from 'react'
import classnames from 'classnames'
import { Logo, parseLinksHeader as parseLinks } from './Links'
import logoLight from '../assets/logo-light.png'
import logoDark from '../assets/logo-dark.png'

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bannerIsOpen: false,
      windowWidth: window.innerWidth
    }
  }

  componentWillMount = () => {
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  render = () => {
    let {
      routes,
      lesserRoutes,
      headerColor,
      toggleMobileTray,
      currentRoute,
      mobileTrayOpen
    } = this.props
    const headerClasses = classnames({
      'header-dark': headerColor === 'DARK',
      'header-light': headerColor === 'LIGHT',
      'header-transparent': headerColor === 'TRANSPARENT'
    })

    const logoPath = headerColor === 'DARK' ? logoDark : logoLight

    const hamburgerPath = classnames({
      '/publicAssets/hamburger-light.svg':
        headerColor === 'LIGHT' || headerColor === 'TRANSPARENT',
      '/publicAssets/hamburger-dark.svg': headerColor === 'DARK'
    })

    if (this.state.windowWidth < 960) {
      return (
        <MobileHeader
          headerClasses={headerClasses}
          logoPath={logoPath}
          hamburgerPath={hamburgerPath}
          routes={routes}
          handleBannerClose={() => this.setState({ bannerIsOpen: false })}
          bannerIsOpen={this.state.bannerIsOpen}
          lesserRoutes={lesserRoutes}
          toggleMobileTray={toggleMobileTray}
          mobileTrayOpen={mobileTrayOpen}
        />
      )
    }
    return (
      <FullHeader
        headerClasses={headerClasses}
        logoPath={logoPath}
        hamburgerPath={hamburgerPath}
        handleBannerClose={() => this.setState({ bannerIsOpen: false })}
        bannerIsOpen={this.state.bannerIsOpen}
        currentRoute={currentRoute}
        routes={routes}
      />
    )
  }
}

function MobileHeader({
  headerClasses,
  lesserRoutes,
  logoPath,
  routes,
  hamburgerPath,
  handleBannerClose,
  bannerIsOpen,
  toggleMobileTray,
  mobileTrayOpen
}) {
  return (
    <div>
      <header className={headerClasses}>
        <div id={'header-center'}>
          <Logo logo={logoPath} />
          <Hamburger
            hamburgerPath={hamburgerPath}
            toggleMobileTray={toggleMobileTray}
          />
          <MobileTray
            routes={routes}
            lesserRoutes={lesserRoutes}
            open={mobileTrayOpen}
          />
        </div>
        {bannerIsOpen && !mobileTrayOpen && (
          <Banner handleClose={handleBannerClose} />
        )}
      </header>
      {/* <TokenCTA /> */}
    </div>
  )
}

function FullHeader({
  headerClasses,
  bannerIsOpen,
  handleBannerClose,
  currentRoute,
  logoPath,
  routes
}) {
  return (
    <div>
      <header className={headerClasses}>
        <div id={'header-center'}>
          <Logo logo={logoPath} />
          <div id={'header-aside'}>{parseLinks(routes, currentRoute)}</div>
        </div>
        {bannerIsOpen && <Banner handleClose={handleBannerClose} />}
      </header>
    </div>
  )
}

function Hamburger({ hamburgerPath, toggleMobileTray }) {
  return (
    <button id={'hamburger'} onClick={toggleMobileTray}>
      <img id={'hamburger-svg'} src={hamburgerPath} alt={'Menu'} />
    </button>
  )
}

function MobileTray({ open, routes, lesserRoutes }) {
  const transform = open ? 'mobileTray-open' : 'mobileTray-closed'
  return (
    <div id={'mobileTray'} className={transform}>
      <div id={'mobileTray-mainLinks'}>{parseLinks(routes)}</div>
      {/* <div id={'mobileTray-lesserLinks'}>{parseLinks(lesserRoutes)}</div> */}
    </div>
  )
}

function Banner({ handleClose }) {
  return
  // return (
  //   <section id={'banner'}>
  //     Meet FOAM team at{' '}
  //     <a href="https://blog.foam.space/foam-at-ethnewyork-7e8a5db85605">
  //       ETH New York
  //     </a>{' '}
  //     @New Lab
  //     <button onClick={handleClose}>{'×'}</button>
  //   </section>
  // )
}

export default Header



// WEBPACK FOOTER //
// ./src/Components/Header.js